export const mainTitle = {
  orgProfile: 'Organization Profile',
  supplierInfo: 'Supplier Info',
  facilityTable: 'Facility Info',
  ownerShip: 'Ownership and Legal Form',
  ownerShipTable: 'Holding Company Information',
  infraProfile: 'Resource Utilization'
};
